import { jsxs as e, jsx as o } from "react/jsx-runtime";
const t = ({ className: r }) => /* @__PURE__ */ e(
  "svg",
  {
    width: "20",
    height: "21",
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    className: r,
    children: [
      /* @__PURE__ */ o(
        "path",
        {
          d: "M12.6786 5.76308L13.8467 4.59494C14.4918 3.9498 15.5378 3.9498 16.183 4.59494C16.8281 5.24008 16.8281 6.28607 16.183 6.93121L15.0148 8.09934M12.6786 5.76308L5.81702 12.6246C4.94593 13.4957 4.51038 13.9313 4.2138 14.462C3.91722 14.9928 3.61883 16.246 3.3335 17.4444C4.5319 17.1591 5.78516 16.8607 6.3159 16.5641C6.84665 16.2675 7.2822 15.832 8.15328 14.9609L15.0148 8.09934M12.6786 5.76308L15.0148 8.09934",
          stroke: "currentColor",
          "stroke-linecap": "round",
          "stroke-linejoin": "round"
        }
      ),
      /* @__PURE__ */ o(
        "path",
        {
          d: "M9.1665 17.4445H14.1665",
          stroke: "currentColor",
          "stroke-linecap": "round"
        }
      )
    ]
  }
);
export {
  t as RenameIcon
};
